#import '../fragments/email-sequence-template-full-fragment.graphql'

query GetUncategorizedEmailSequenceTemplates(
    $creatorIds: [ID!]
    $onlyArchived: Boolean
    $includeShared: Boolean
    $search: String
    $includeUnsharedFromOthers: Boolean
) {
    emailSequenceTemplateGroups {
        uncategorized(
            creatorIds: $creatorIds
            onlyArchived: $onlyArchived
            includeShared: $includeShared
            search: $search
            includeUnsharedFromOthers: $includeUnsharedFromOthers
        ) {
            ...EmailSequenceTemplateFullFragment
        }
    }
}
